import { c as _c } from "react/compiler-runtime";
import { pick } from 'lodash';
import { useLocale } from 'next-intl';
import { milestonesDemoData } from './constants';
import type { DemoDonationAmount } from './types';
import { useApiV4WithDemoData } from '@/api';
function* demoDonationAmountGenerator(): Generator<DemoDonationAmount, DemoDonationAmount, DemoDonationAmount> {
  const amounts = [milestonesDemoData[0]!.amountInCents - 1000, milestonesDemoData[0]!.amountInCents + 1000, milestonesDemoData[1]!.amountInCents - 1000, milestonesDemoData[1]!.amountInCents + 1000, milestonesDemoData[2]!.amountInCents - 1000, milestonesDemoData[2]!.amountInCents + 1000, milestonesDemoData[3]!.amountInCents - 1000, milestonesDemoData[3]!.amountInCents + 1000];
  let index = 0;
  while (true) {
    yield {
      donated_amount_in_cents: amounts[index]!
    };
    if (index < amounts.length - 1) {
      index++;
      continue;
    }
    index = 0;
  }
}
function useDonationAmountData(fundraisingEventId, t0, withDemoData) {
  const $ = _c(3);
  const donationAmount = t0 === undefined ? demoDonationAmountGenerator : t0;
  const locale = useLocale();
  const demoData = withDemoData ? donationAmount : undefined;
  let t1;
  if ($[0] !== locale) {
    t1 = {
      locale
    };
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      selector(data) {
        if (!data) {
          return null;
        }
        return pick(data, ["donated_amount_in_cents"]);
      },
      intervalMs: 5000
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return useApiV4WithDemoData(`/fundraising_events/${fundraisingEventId}`, t1, t2, demoData);
}
export default useDonationAmountData;